import React, { useState } from 'react';

function AddDrawer({ onClose, onSave, isSaving }) {
  const [formData, setFormData] = useState({ id: '', destinationURL: '', cap: '', api_identifier: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isSaving) onSave(formData);
  };

  return (
    <>
      <div className="drawer-backdrop" onClick={onClose}></div>
      <div className="drawer">
        <form onSubmit={handleSubmit} style={{ display: 'contents' }}>
          <div className="drawer-header">
            <h2>Add Link</h2>
            <button type="button" onClick={onClose} className="close-btn">&times;</button>
          </div>
          <div className="drawer-content">
            <div className="form-group">
              <label htmlFor="id">Link ID (optional)</label>
              <input
                id="id"
                name="id"
                type="text"
                value={formData.id}
                placeholder="Leave blank to auto-generate"
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="api_identifier">API Identifier</label>
              <input
                id="api_identifier"
                name="api_identifier"
                type="text"
                value={formData.api_identifier}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="destinationURL">Destination URL</label>
              <input
                id="destinationURL"
                name="destinationURL"
                type="text"
                value={formData.destinationURL}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="cap">Cap</label>
              <input id="cap" name="cap" type="number" value={formData.cap} onChange={handleChange} />
            </div>
          </div>
          <div className="drawer-footer">
            <button type="button" onClick={onClose} className="btn subtle">Cancel</button>
            <button type="submit" className="btn primary" disabled={isSaving}>
              {isSaving ? 'Saving...' : 'Add Link'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default AddDrawer;
